module.exports = __webpack_public_path__ + "static/media/dixon.e5711683.png";